import { DARK_MODE } from "./dark-mode";

export const SlashID = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <path
      d="M10.1489 8L1.6001 24.1824H4.1585L12.7073 8H10.1489Z"
      fill="#2A6AFF"
    />
    <path
      d="M15.8339 12.5552C16.7499 12.5552 17.4979 11.7856 17.4979 10.8704C17.4979 9.9552 16.7499 9.1856 15.8339 9.1856C14.8979 9.1856 14.1499 9.9552 14.1499 10.8704C14.1499 11.7856 14.8979 12.5552 15.8339 12.5552ZM14.4619 14.0112V24.1824H17.1659V14.0112H14.4619ZM27.3507 8V14.8016C26.5377 14.1118 25.5049 13.7356 24.4387 13.7408C21.4851 13.7408 19.2595 16.112 19.2595 19.1072C19.2595 22.1024 21.4851 24.4736 24.4387 24.4736C25.6659 24.4736 26.7475 24.016 27.5587 23.2256V24.1824H30.0547V8H27.3507ZM24.7507 21.936C23.1907 21.936 22.0467 20.7296 22.0467 19.1072C22.0467 17.4848 23.1907 16.2784 24.7507 16.2784C26.3107 16.2784 27.4547 17.4848 27.4547 19.1072C27.4547 20.7296 26.3107 21.936 24.7507 21.936Z"
      fill="#142049"
    />
  </svg>
);
